import { useContext } from 'react';
import FormControl from '@mui/material/FormControl';
import FormHelperText from '@mui/material/FormHelperText';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import inputFieldSize from './inputFieldSize';
import genderOptions from './genderOptions';
import { Context } from '../../Provider';
import InputRequired from '../../../common/InputRequired';

// Gender selector field
const SelectorGenderField = ({ register, errors, readOnly }) => {
    const { state } = useContext(Context);
    const { ftm } = state;

    return (
        <FormControl error={!!errors.ftm_gender} fullWidth>
            <strong>Gender <InputRequired/></strong>
            <TextField
                size={inputFieldSize}
                select
                defaultValue={ftm?.ftm_gender || "0"}
                {...register("ftm_gender", { required: 'Gender is required' })}
                InputProps={{
                    readOnly: readOnly,
                }}
                sx={{
                    '& .MuiInputBase-root': {
                      backgroundColor: readOnly ? '#f5f5f5' : 'inherit', // light gray when readonly
                    },
                }}
            >
                <MenuItem value="0" disabled>Select gender</MenuItem>
                {genderOptions.map((gender, index) => (
                    <MenuItem key={index} value={gender.gender_id}>{gender.gender_name}</MenuItem>
                ))}
            </TextField>
            {errors.ftm_gender && (
                <FormHelperText>{errors.ftm_gender.message}</FormHelperText>
            )}
        </FormControl>
    );
};

export default SelectorGenderField;